module.exports = __webpack_public_path__ + "img/exclamation-mark-icon.7a2449a2.svg";